import { render, staticRenderFns } from "./IconLogo.vue?vue&type=template&id=274e0b93&scoped=true&"
var script = {}
import style0 from "./IconLogo.vue?vue&type=style&index=0&id=274e0b93&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274e0b93",
  null
  
)

export default component.exports